import { render, staticRenderFns } from "./PriceDetail.vue?vue&type=template&id=dfe81880&scoped=true&"
import script from "./PriceDetail.vue?vue&type=script&lang=js&"
export * from "./PriceDetail.vue?vue&type=script&lang=js&"
import style0 from "./PriceDetail.vue?vue&type=style&index=0&id=dfe81880&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dfe81880",
  null
  
)

export default component.exports